<!--
 * @Editor: chenqy
 * @Description:
 * @Date: 2023-06-19 17:25:53
 * @LastEditors: Chenqy
 * @LastEditTime: 2024-01-25 17:42:00
-->
<template>
  <div style="width:100%">
    <ds-date-picker
      v-model="value"
      :type="pickerType"
      :period-type="chooseType"
      :format="format"
      :value-format="valueFormat"
      :clearable="item.isClearable !== false"
      style="width:100%"
      popperClass="ds-date-picker-panel"
      @change="change"
    />
  </div>
</template>
<script>
import { createDatePicker } from "../../date/date-picker";

const ElDatePicker = ELEMENT.DatePicker;
const DsDatePicker = createDatePicker(ElDatePicker);
export default {
  name: "DsfSuperSearchPeriod",
  components: {
    DsDatePicker,
  },
  props: {
    isRange: {
      type: Boolean,
      default: false,
    },
    chooseType: {
      type: String,
      default() {
        return "MD";
      },
    },
    values: {
      type: [Date, Array, String],
      default() {
        return null;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formats: {
        HY: "yyyy-MM",
        SS: "yyyy-MM",
        MD: "yyyy-MM-dd",
      },
      valueFormats: {
        HY: "yyyy-MM-dd",
        SS: "yyyy-MM-dd",
        MD: "yyyy-MM-dd",
      },
      value: null,
    };
  },
  computed: {
    format() {
      return this.formats[this.chooseType];
    },
    valueFormat() {
      return this.valueFormats[this.chooseType];
    },
    pickerType() {
      if (this.chooseType == "MD") {
        return this.isRange ? "daterange" : "date";
      }
      return this.isRange ? "monthrange" : "month";
    },
  },
  methods: {
    focus() {
      this.$emit("focus");
    },
    change() {
      const eDate = this.value?.[1];
      if (this.isRange && eDate) {
        this.$emit("update:values", [this.value[0], this.handleEndDate(true, eDate)]);
      } else {
        this.$emit("update:values", this.value);
      }
      this.$nextTick(() => {
        this.$emit("change");
      });
    },
    /**
     * @description: 范围选择重新计算最后日期（比如季度选择2021第一季度到第二季度组件正确返回为2021-1-1至2021-6-30， 但现在返回为2021-1-1至2021-4-1）
     * @param {Boolean} isV2ToV  value2计算value, 否则反之
     * @param {Date || string || number} edate 转换的时间
     * @return {Date string}
     */
    handleEndDate(isV2ToV, edate) {
      let mapping = {
        MD: {
          1: 10,
          11: 20,
          21: 0,
        },
        SS: {
          1: 3,
          4: 6,
          7: 9,
          10: 12,
        },
        HY: {
          1: 6,
          7: 12,
        },
      };
      const endDate = new Date(edate);
      const currentYear = endDate.getFullYear();
      const currentMonth = endDate.getMonth() + 1;
      const currentDay = endDate.getDate();
      let edate1 = "";
      if (isV2ToV) {
        const m = mapping[this.chooseType];
        if (this.chooseType === "MD") {
          const day = m[currentDay];
          edate1 = new Date(currentYear, day === 0 ? currentMonth : currentMonth - 1, day, 23, 59, 59);
        } else {
          edate1 = new Date(currentYear, m[currentMonth], 0, 23, 59, 59);
        }
      } else {
        const m = Object.entries(mapping[this.chooseType]).reduce((initValue, [key, value]) => {
          initValue[value] = key;
          return initValue;
        }, {});
        if (this.chooseType === "MD") {
          const day = _.inRange(currentDay, 1, 11) ? 1 : _.inRange(currentDay, 11, 21) ? 11 : 21;
          edate1 = new Date(currentYear, currentMonth - 1, day);
        } else {
          edate1 = new Date(currentYear, m[currentMonth] - 1, 1);
        }
      }
      return dsf.date.format(edate1, "yyyy-mm-dd");
    },
  },
  watch: {
    values: {
      handler(v, ov) {
        const eDate = v?.[1];
        if (this.isRange && eDate) {
          this.value = [v[0], this.handleEndDate(false, eDate)];
        } else {
          this.value = v;
        }
      },
      immediate: true,
    },
  },
};
</script>